import { TotalOdd,CalaculationRequest } from '../types';

type ServerResponse = Record<
  string,
  number | { odds: number; cleanOdds: number | null }
>;

export const calculateOdds = async (
  brandId: string,
  request: CalaculationRequest,
  apiUrl: string
): Promise<TotalOdd[]> => {
  if (!request.BetBuilderEvents.length) return [];

  request.BetBuilderEvents = request.BetBuilderEvents.filter(
    event => event.Selections.length > 1
  );

  const body: any = request;

  if (body.BetBuilderEvents.length === 0) return [];

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'BrandId': brandId
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error('Failed to calculate odds');
    }

    const data: ServerResponse = await response.json();

    const odds: TotalOdd[] = Object.entries(data).map(([key, value]) => {
      let odd: number;

      if (typeof value === 'number') {
        // old format
        odd = value;
      } else if (
        typeof value === 'object' &&
        value !== null &&
        typeof value.odds === 'number'
      ) {
        // new format
        odd = value.odds;
      } else {
        throw new Error(`Unexpected value for odds at key ${key}`);
      }

      return {
        eventId: key,
        odd
      };
    });

    if (odds.length === 0 || odds[0].odd === 0) {
      throw new Error('Result Is 0');
    }

    return odds;
  } catch (error) {
    throw error;
  }
};